var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-viewer"},[_c('iframe',{staticClass:"viewer",attrs:{"src":_vm.url,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }